// PointsContext.js
import React, { createContext, useState, useEffect } from 'react';

export const PointsContext = createContext();

export const PointsProvider = ({ children }) => {
  const [points, setPoints] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [pointsHistory, setPointsHistory] = useState([]);

  useEffect(() => {
    // TODO: Fetch user points from Firebase
  }, []);

  const addPoints = async (amount, reason) => {
    // TODO: Implement add points logic
    console.log('Add points:', amount, reason);
    setPoints(prevPoints => prevPoints + amount);
  };

  const updatePoints = (newPoints) => {
    setPoints(newPoints);
  };

  const fetchPointsHistory = async () => {
    // TODO: Fetch points history from Firebase
    console.log('Fetch points history');
  };

  const value = {
    points,
    pointsHistory,
    addPoints,
    updatePoints,
    fetchPointsHistory,
  };

  return <PointsContext.Provider value={value}>{children}</PointsContext.Provider>;
};
